import { Box, TextField, Typography } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import RegularButton from "components/CustomButtons/Button";
import { useForm } from "hooks/useForm";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { editGasMovement } from "redux/actions/gasMovementsRequests/gasMovementsRequestActions";
import { AutocompleteComponent } from "components/Autocomplete/AutocompleteComponent";
import { filterMovements } from "../filterMovements";
import { isTransferMovement } from "./initialValues";
import { useTransferWarehouses } from "./useTransferWarehouses";

export const GMConfirmationForm = ({
  mov,
  onClose,
  action,
}) => {
  const dispatch = useDispatch();
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { movementsArr } = useSelector(({ gasMovements }) => gasMovements);
  const { station } = useSelector(
    ({ gasMovementsRequests }) => gasMovementsRequests
  );
  const { stationsList } = useSelector(({ companies }) => companies);
  const { inputValues, handleNewValues: setValues } = useForm({
    idGasMovement:
      movementsArr.find(
        (mv) => mv.movement === mov.movement || mv.label === mov.movement
      ) || null,
    comment: "",
    idStationDestino: mov.idStationDestino
      ? (typeof mov.idStationDestino === "object"
        ? mov.idStationDestino
        : stationsList.find((s) => s.id === mov.idStationDestino) || null)
      : null,
    idStorageDestino: null,
  });
  const { idGasMovement } = inputValues;
  const { unitType } = mov;

  const isTransfer = isTransferMovement(idGasMovement);

  const { warehouseOptions } = useTransferWarehouses({
    isTransfer,
    stationDestino: inputValues.idStationDestino,
    mov,
    setValues,
  });

  const submit = (e) => {
    e.preventDefault();
    if (!idGasMovement) return;

    const body = {
      ...mov,
      movement: idGasMovement.label,
      movementType: idGasMovement.movementType,
      ...(isTransfer && {
        idStationDestino: inputValues.idStationDestino,
        idStorageDestino: inputValues.idStorageDestino,
        stationDestino: inputValues.idStationDestino?.label || inputValues.idStationDestino?.name || "",
        storageDestino: inputValues.idStorageDestino?.label || inputValues.idStorageDestino?.number || "",
      }),
    };
    const mergedComment = mov.comment && inputValues.comment
      ? `${mov.comment} / ${inputValues.comment}`
      : mov.comment || inputValues.comment || "";

    const form = {
      id: mov.id,
      idStation: station?.id,
      idGasMovement: idGasMovement.id,
      comment: mergedComment,
      ...(isTransfer && {
        idStationDestino: inputValues.idStationDestino?.id,
        idStorageDestino: inputValues.idStorageDestino?.id,
      }),
    };

    dispatch(editGasMovement(body, form, () => action(mergedComment)));
  };

  const movementsFiltered = filterMovements(unitType, movementsArr);

  return (
    <Box
      style={{
        display: "flex",
        justifyContent: "flex-end",
        flexWrap: "wrap",
        gap: 10,
      }}
    >
      <Autocomplete
        id="unit-autocomplete"
        options={movementsFiltered}
        value={idGasMovement}
        getOptionLabel={(mov) => mov.label || ""}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Tipo de Movimiento"
            variant="outlined"
          />
        )}
        required={true}
        fullWidth
        onChange={(e, v) =>
          setValues({
            idGasMovement: v,
          })
        }
        disabled={isLoadingComp?.GM_approveLoading}
      />
      {isTransfer && (
        <>
          <AutocompleteComponent
            name="idStationDestino"
            label="Planta Destino"
            options={stationsList}
            value={inputValues.idStationDestino}
            handleValues={(vals) => setValues({ ...vals, idStorageDestino: null })}
            sort
          />
          <AutocompleteComponent
            name="idStorageDestino"
            label="Almacén Destino"
            options={warehouseOptions}
            value={inputValues.idStorageDestino}
            handleValues={setValues}
            disabled={!inputValues.idStationDestino}
            sort
          />
        </>
      )}
      <Box
        style={{
          width: "100%",
          marginTop: 10,
          border: "1px solid rgba(0,0,0,0.23)",
          borderRadius: 4,
          padding: "10px 14px",
        }}
      >
        <Typography
          variant="caption"
          style={{ color: "rgba(0,0,0,0.54)", display: "block", marginBottom: 4 }}
        >
          Comentario
        </Typography>
        {mov.comment && (
          <Typography
            variant="body2"
            style={{
              color: "rgba(0,0,0,0.6)",
              backgroundColor: "rgba(0,0,0,0.04)",
              borderRadius: 4,
              padding: "6px 8px",
              marginBottom: 8,
              whiteSpace: "pre-wrap",
            }}
          >
            {mov.comment}
          </Typography>
        )}
        <TextField
          placeholder="Añadir al comentario..."
          variant="outlined"
          fullWidth
          multiline
          rows={3}
          value={inputValues.comment}
          onChange={(e) => setValues({ comment: e.target.value })}
          disabled={isLoadingComp?.GM_approveLoading}
        />
      </Box>
      <RegularButton color="transparent" onClick={onClose}>
        cancelar
      </RegularButton>
      <RegularButton
        color="info"
        onClick={submit}
        size="sm"
        loading={isLoadingComp?.GM_approveLoading}
      >
        Confirmar
      </RegularButton>
    </Box>
  );
};
